import api from "core/api/api";

export default {
    wizardType: "SNOWFLAKE",

    getConnectionParams: (type, model) => ({
        useConnectionProfile: true,
        connectionProfileName: model.get("connectionProfileName"),
    }),

    async fetchTableWrapper(model, agentName, metaObjectFQN, adapterName_version) {
        return api.WizardHelper_GetDBs("SNOWFLAKE", {
            useConnectionProfile: true,
            connectionProfileName: model.get("connectionProfileName"),
        }, agentName, metaObjectFQN, adapterName_version);
    },
};

